export default "__VITE_ASSET__aeb040ed__"